module.exports = __webpack_public_path__ + "static/media/arrow-left.bef6349d.svg";